import {
  Button,
  ChevronDownIcon,
  Divider,
  EditIcon,
  LimitsIcon,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  SecureIcon,
  TerminateCardIcon,
  useAnchor,
} from '@razz-team/ui-web';
import { ApiCard } from '../../../openapi';
import { useTranslation } from 'react-i18next';
import { TerminateCardDialog } from './TerminateCardDialog';
import { useBoolean } from 'usehooks-ts';

export function isMoreAvailable(card: ApiCard) {
  return card.status === 'ACTIVE';
}

export function CardMoreButton({
  card,
  isLimitsEnabled,
  isTerminateEnabled,
}: {
  card: ApiCard;
  isLimitsEnabled: boolean;
  isTerminateEnabled: boolean;
}) {
  const { t } = useTranslation();
  const anchor = useAnchor<HTMLButtonElement>();
  const terminateFlag = useBoolean(false);

  return (
    <>
      <Button
        id="card-more-button"
        color="secondary"
        onClick={anchor.onOpen}
        endIcon={<ChevronDownIcon />}
        aria-controls={anchor.open ? 'card-more-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={anchor.open ? 'true' : undefined}
      >
        {t('More')}
      </Button>
      <Menu
        id="card-more-menu"
        open={anchor.open}
        anchorEl={anchor.element}
        onClose={anchor.onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        slotProps={{
          list: {
            'aria-labelledby': 'card-more-button',
          },
        }}
      >
        <MenuItem>
          <ListItemButton sx={{ p: 0 }} href={`/account/cards/${card.id}/name`}>
            <ListItemIcon>
              <EditIcon />
            </ListItemIcon>
            <ListItemText>{t('Rename')}</ListItemText>
          </ListItemButton>
        </MenuItem>
        {isLimitsEnabled ? (
          <MenuItem>
            <ListItemButton sx={{ p: 0 }} href={`/account/cards/${card.id}/limits`}>
              <ListItemIcon>
                <LimitsIcon />
              </ListItemIcon>
              <ListItemText>{t('Limits')}</ListItemText>
            </ListItemButton>
          </MenuItem>
        ) : null}
        {card.cardIssuer !== 'MARQETA' ? (
          <MenuItem>
            <ListItemButton sx={{ p: 0 }} href={`/account/cards/${card.id}/security`}>
              <ListItemIcon>
                <SecureIcon />
              </ListItemIcon>
              <ListItemText>{t('Security')}</ListItemText>
            </ListItemButton>
          </MenuItem>
        ) : null}
        {isTerminateEnabled ? (
          <>
            <Divider />
            <MenuItem onClick={terminateFlag.setTrue}>
              <ListItemIcon>
                <TerminateCardIcon color="error" />
              </ListItemIcon>
              <ListItemText>{t('Close card')}</ListItemText>
            </MenuItem>
            <TerminateCardDialog
              open={terminateFlag.value}
              card={card}
              onCancel={terminateFlag.setFalse}
            />
          </>
        ) : null}
      </Menu>
    </>
  );
}
